import { PropsWithChildren, ReactNode } from "react"
import { Stack, Typography } from "@mui/material"

export type LabeledFieldProps = Readonly<
    PropsWithChildren<{
        label: ReactNode
        bold?: boolean
        className?: string
    }>
>

export function LabeledField({ label, bold = true, className, children }: LabeledFieldProps) {
    return (
        <Stack gap="0.5rem" className={className}>
            <Typography variant="body1" fontWeight={bold ? "500" : undefined} color="text.secondary">
                {label}
            </Typography>
            {children}
        </Stack>
    )
}
